import React from 'react';
import PropTypes from 'prop-types';

const LogoMarkPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M16.044 30.5a4.806 4.806 0 0 1-4.677-3.686.09.09 0 0 0-.055-.062 12.618 12.618 0 0 1-1.824-.914.09.09 0 0 1-.037-.045 12.737 12.737 0 0 1-.633-6.94.09.09 0 0 1 .063-.07H8.9a.09.09 0 0 1 .072.026 12.615 12.615 0 0 0 4.182 2.984.09.09 0 0 0 .088-.01 4.792 4.792 0 0 1 6.58.947.09.09 0 0 0 .07.034h.012a12.813 12.813 0 0 0 8.038-4.375.09.09 0 0 1 .154.083 12.675 12.675 0 0 1-7.332 8.259.09.09 0 0 0-.056.062 4.796 4.796 0 0 1-4.663 3.707zm-8.966-6.597a.088.088 0 0 1-.064-.026A12.52 12.52 0 0 1 3.54 13.402a.09.09 0 0 0-.028-.078 4.808 4.808 0 0 1-.878-5.887 4.8 4.8 0 0 1 5.517-2.224.089.089 0 0 0 .081-.016 12.383 12.383 0 0 1 1.708-1.14.09.09 0 0 1 .043-.012 12.71 12.71 0 0 1 6.353 2.933.09.09 0 0 1-.039.156 12.6 12.6 0 0 0-4.685 2.136.09.09 0 0 0-.037.081c.017.162.026.324.026.487a4.826 4.826 0 0 1-4.136 4.745.09.09 0 0 0-.07.056 12.832 12.832 0 0 0-.234 9.146.09.09 0 0 1-.083.118zm15.735-4.477a.09.09 0 0 1-.086-.116c.506-1.633.675-3.352.498-5.053a.09.09 0 0 0-.052-.072 4.827 4.827 0 0 1-2.783-4.347 4.771 4.771 0 0 1 .356-1.832.09.09 0 0 0-.012-.089 12.814 12.814 0 0 0-7.842-4.844.09.09 0 0 1-.006-.175 12.478 12.478 0 0 1 10.875 2.301.09.09 0 0 0 .082.016 4.655 4.655 0 0 1 1.34-.198c2.65 0 4.81 2.152 4.817 4.797 0 1.33-.55 2.6-1.518 3.512a.09.09 0 0 0-.028.078c.076.557.114 1.118.115 1.68 0 .053-.003.105-.007.156l-.006.099c0 .02-.007.04-.02.055a12.712 12.712 0 0 1-5.694 4.028l-.03.004z"
    />
  );
};

LogoMarkPath.propTypes = {
  fill: PropTypes.string,
};

export default LogoMarkPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/logos/logo-mark.jsx